import { gql } from '@apollo/client/core'

import { ADDRESS_ATTRIBUTES, PAGE_INFO_ATTRIBUTES } from './fragments'

const FETCH_PROJECT_PRODUCTS = gql`
  query fetchProjectProducts($id: ID!) {
    project(id: $id) {
      id
      latitude
      longitude
      address {
        ...addressAttributes
      }
      products {
        id
        name
        imageUrl
        returnDate
        rentalId
        categorySegment {
          name
        }
        currentLocation {
          latitude
          longitude
          recordedAt
        }
      }
    }
  }
  ${ADDRESS_ATTRIBUTES}
`

const PAGINATED_PROJECT_QUERY = gql`
  query projects(
    $first: Int
    $last: Int
    $offset: Int
    $after: String
    $before: String
    $query: String
    $scope: String
    $id: [ID!]
    $withInvoices: Boolean
    $sort: [SortOptions!] = [{ sortField: "created_at", sortDirection: "desc" }]
  ) {
    projects: projectsPaginated(
      first: $first
      last: $last
      offset: $offset
      after: $after
      before: $before
      query: $query
      scope: $scope
      id: $id
      withInvoices: $withInvoices
      sort: $sort
    ) {
      nodes {
        id
        startDate
        endDate
        latitude
        longitude
        name
        stage
        address {
          ...addressAttributes
        }
      }
      pageInfo {
        ...pageInfoAttributes
      }
      totalCount
      maxPageSize
      pageIndex
    }
  }
  ${PAGE_INFO_ATTRIBUTES}
  ${ADDRESS_ATTRIBUTES}
`
const ADD_PRODUCT_INSTANCE_BOOKING = gql`
  mutation addProductInstanceBooking(
    $id: ID!
    $productInstanceId: ID!
    $startDate: String!
    $returnDate: String!
  ) {
    addProductInstanceBooking(
      id: $id
      productInstanceId: $productInstanceId
      startDate: $startDate
      returnDate: $returnDate
    ) {
      id
      name
      startDate
      returnDate
      productInstance {
        id
        name
        status
        serialNumber
        assignedToProject
      }
    }
  }
`
export { FETCH_PROJECT_PRODUCTS, PAGINATED_PROJECT_QUERY, ADD_PRODUCT_INSTANCE_BOOKING }
